/* @jsx h */
import { defineComponent, h, watch } from "vue";
import {} from "@lemmonhq/types";
import { ShopHeader } from "./ShopHeader/index";
import { useRoute } from "vue-router";
import { useMenu } from "@app/vue/providers/Menu";
import { useLocalization, SwissMade } from "@lemmonhq/uikit";

export const ShopLayout = defineComponent({
  name: "ShopLayout",
  setup(props, { slots }) {
    const route = useRoute();
    const {} = useMenu();
    watch(route, () => {
      console.log("route changed", route);
    });
    return () => (
      <>
        <div
          style="padding-bottom: 0px;"
          class="relative min-h-screen flex flex-col"
        >
          <ShopHeader />
          <div class="flex-1 flex flex-col">{slots.default?.()}</div>
        </div>
        <ShopFooter />
      </>
    );
  },
});

export const LegalDisclamair = defineComponent({
  setup(props) {
    const { shop } = useMenu();
    const { t } = useLocalization();
    return () => {
      return (
        <div class="text-xs max-w-[800px]">
          {t("customer.shop_shell.legal_prefix")}{" "}
          <a
            target="_blank"
            href="https://www.thelemmon.ch/fr/t-c"
            class="font-semibold  text-accent"
          >
            {t("customer.shop_shell.terms_and_conditions")}
            <span class="material-symbols-outlined text-xs relative">
              open_in_new
            </span>
          </a>
        </div>
      );
    };
  },
});

export const ShopFooter = defineComponent({
  name: "MenuLayout",
  setup() {
    const { t } = useLocalization();
    return () => {
      const {} = useMenu();

      return (
        <div class="border-t  bg-base-200 mt-12  flex">
          <div class="flex flex-col gap-3 p-4  flex-1 ">
            <div class=" flex-1">
              <p class="font-semibold ">
                <a
                  target="_blank"
                  href="https://lemmonpos.ch"
                  class="font-semibold text-accent"
                >
                  {t("customer.shop_shell.powered_by_lemmon")}
                </a>
              </p>
              <p class="">
                {t("customer.shop_shell.made_with")}{" "}
                <span class="text-[#ed2224]">♥</span>
              </p>
            </div>
          </div>
          <div class="pt-4 px-4 flex items-start justify-end ">
            <SwissMade width={35} />
          </div>
        </div>
      );
    };
  },
});
